import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  readonly IMG_URL = 'https://marketsmojostatic.motilaloswaluat.com/';
  readonly FRAPI_URL = 'https://marketsmojoapi.motilaloswaluat.com/';
  readonly MOJO_WEB_URL = 'https://marketsmojo.motilaloswaluat.com/';
  readonly MOJO_STOCK_URL = 'https://marketsmojo.motilaloswaluat.com/stocks-analysis/';
  readonly MOJO_URL = 'https://marketsmojo.motilaloswaluat.com/';
  readonly APIV1_URL = 'https://marketsmojoapi.motilaloswaluat.com/apiv1/';
  readonly APIV1_URL_S = 'https://marketsmojoapi.motilaloswaluat.com/apiv1/';
  readonly JS_URL = 'https://marketsmojostatic.motilaloswaluat.com/';
  readonly PARTNER_URL = 'https://www.mojomarkets.in/';

  constructor() {}
}
